import { translate } from '@/translation/translate.ts';
import { Slide } from '@/eventConfig/types.ts';
import { FC } from 'react';
import { useSaveRegistration } from '@/saveRegistration/useSaveRegistration.ts';

interface GridCheckTextProps {
  slide: Slide;
}

export const TransmitRegistrationText: FC<GridCheckTextProps> = ({ slide }) => {
  const { transmit, transmitRegistrationStatus } = useSaveRegistration();

  const retryTransmission = () => {
    transmit();
  };

  const Failure = (
    <>
      <span>{translate(slide?.transmitRegistration?.backendFailure)}</span>
      <div>
        <button onClick={retryTransmission}>{translate(slide?.transmitRegistration?.retry)}</button>
      </div>
    </>
  );

  switch (transmitRegistrationStatus) {
    case 'unknown':
      return (
        <>
          <span>{translate(slide?.transmitRegistration?.unknown)}</span>
          <span></span>
        </>
      );
    case 'transmitting':
      return (
        <>
          <span>{translate(slide?.transmitRegistration?.transmitting)}</span>
          <span></span>
        </>
      );
    case 'transmitted-success':
      return (
        <>
          <span>{translate(slide?.transmitRegistration?.success)}</span>
          <span></span>
        </>
      );
    case 'transmitted-failure':
      return Failure;
    case 'transmitted-unknown-failure':
      return Failure;
    default:
      return Failure;
  }
};
